module.exports = __webpack_public_path__ + "static/media/shuttleLuxuryIcon.0543e83c.png";